import React from 'react';
import { PayoutListPage } from './list';

export const PayoutsModule = () => {
  return <PayoutListPage />;
};
